import { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  RadioGroup,
  Radio,
  TableBody,
  TableRow,
  useTheme,
  TableContainer,
} from '@mui/material';
import Form from 'components/Form';
import {
  StyledTableCellTwo,
  StyledTableCellWithoutLeftTwo,
  StyledTableCellWithoutLeftRightTwo,
} from 'routes/Main/style';
import SectionTitle from '../../components/SectionTitle';

import { IFormValues, IFormWatch, IFormRegister } from 'routes/Main/type';

const radioId = [
  'no01',
  'no02',
  'no03',
  'no04',
  'no05',
  'no06',
  'no07',
  'no08',
  'no09',
];

const 영역1 = [
  {
    id: 1,
    ko: '1. 체온 & 호흡 측정 (BT & RR)',
    info: [
      '직접 또는 모니터로 호흡수, 체온을 측정하고 기록하는데 소요되는 시간으로 호흡수와 체온을 모두 측정한 경우 해당된다.',
    ],
    desc: ['해당 없음', '1점 : 3~5회', '2점 : 6~12회', '4점 : 13회'],
  },
  {
    id: 2,
    ko: '2. 감시기기 모니터링-1',
    info: ['ABP, NIBP, HR, SpO2, ETCO2 중 3가지 이상을 측정한 경우 해당된다.'],
    desc: ['해당 없음', '2점 : 3~5회', '4점 : 6~12회', '8점 :13회 이상'],
  },
  {
    id: 3,
    ko: '3. 감시기기 모니터링-2',
    info: [
      'CVP. PAP/PCWP/RAP 중 1가지 이상 측정한 경우 해당한다.',
      'CVP의 경우 물기둥을 이용해 측정한 경우에도 해당된다.',
    ],
    desc: ['해당 없음', '2점 : 3~5회', '4점 : 6~12회', '8점 :13회 이상'],
  },
  {
    id: 4,
    ko: '4. 심박출량 모니터링',
    info: ['CO, CI, SVI, SVV 중 1가지 이상 측정하고 기록하는 경우 해당된다.'],
    desc: ['해당 없음', '5점'],
  },
  {
    id: 5,
    ko: '5. 뇌내압측정',
    info: [
      'EVD나 뇌압측정 기기의 모니터를 통해 감시하는 경우 모두 해당된다.',
      'EVD로 통해 배액만 하는 경우는 해당되지 않는다.',
    ],
    desc: ['해당 없음', '1점 : 3~5회', '2점 : 6~12회', '5점 : 13회 이상'],
  },
  {
    id: 6,
    ko: '6. 수분 섭취 및 배설량 측정',
    info: [
      '섭취량과 배설량을 모두 측정한 경우에만 해당된다. (한가지만 측정할 경우에는 해당되지 않음)',
      '배설량은 소변과 기타 배액량을 재거나 무게를 측정하는 경우 포함된다.',
    ],
    desc: [
      '해당 없음',
      '2점 : q6~8시간',
      '4점 : q4시간',
      '6점 : q2시간',
      '15점 : q1시간',
    ],
  },
  {
    id: 7,
    ko: '7. 침상체중 측정',
    info: [
      'Inbed scale을 이용하거나 중환자 침대를 이용하여 체중을 측정하는 경우에만 해당된다.',
    ],
    desc: ['해당 없음', '2점'],
  },
  {
    id: 8,
    ko: '8. 침습적 압력 측정을 위한 감시기 설치',
    info: [
      '모니터링 세트를 교환하거나 카테터를 새로 삽입할 때에 시행되는 모니터 설정, 압력백 준비, 케이블 연결 등의 행위 등이 해당된다.',
      'ABP, CVP, S_G cath, CO 각 장치별 1회로 간주한다.',
      '카테터 삽입은 별도 산정한다.',
    ],
    desc: ['해당 없음 ', '1회당 2점 :'],
  },
  {
    id: 9,
    ko: '9. IABP나 ECMO 유지',
    info: [
      'IABP나 ECMO 중 1가지 이상 유지할 경우 해당된다.',
      '심폐기능 모니터링, 회로의 유지, 환자반응, 말초순환상태사정, 알람에 대한 조정을 포함한다.',
    ],
    desc: ['해당 없음', '6점'],
  },
];

const radioId1 = [
  'no10',
  'no11',
  'no12',
  'no13',
  'no14',
  'no15',
  'no16',
  'no17',
  'no18',
];

const 영역2 = [
  {
    id: 1,
    ko: '10. 의식상태 관찰',
    info: [
      'GCS, P/S, L/R, Muscle power, BIS monitoring 중 3가지 이상 사정한 경우만 해당된다.',
    ],
    desc: ['해당 없음', '2점 : 3~4회', '8점 : 5~10회', '10점 : 11회 이상'],
  },
  {
    id: 2,
    ko: '11. 호흡음 청진 및 기록',
    info: [
      '기도흡인, 물리요법 등과 같은 호흡간호 시 시행한 내용은 제외되며, 간호기록이 있어야 한다.',
    ],
    desc: ['해당 없음', '2점 : 3회 이상'],
  },
  {
    id: 3,
    ko: '12. 순환/감각/운동 확인 3회 이상',
    info: [
      'SMC 확인으로 2가지 이상 항목을 3회 이상 확인하고 기록한 경우에만 해당된다.',
    ],
    desc: ['해당 없음', '2점 : 3회 이상'],
  },
  {
    id: 4,
    ko: '13. 기타사정 (낙상, 통증, 욕창, 진정)',
    info: [
      '도구를 사용하여 측정한 경우만 해당된다. 낙상, 통증, 욕창, 진정 중 종류와 상관없이 사정 횟수가 5회 이상일 경우 해당된다.',
      '동일 내용 사정을 반복한 경우 모두 횟수로 인정한다.',
    ],
    desc: ['해당 없음', '3점 : 총 5회 이상'],
  },
  {
    id: 5,
    ko: '14. 혈당검사',
    info: ['검사실에서 시행한 검사는 해당되지 않는다.'],
    desc: ['해당 없음', '2점 : 3~6회', '4점 : 7회'],
  },
  {
    id: 6,
    ko: '15. 현장응급검사시행(혈당검사 제외)',
    info: [
      'ABG, USG, ACT검사 등이 포함되며, 동일검사를 반복한 경우에도 모두 횟수로 인정한다. 혈당검사는 제외한다.',
      '중환자실 직원이 중환자실 내에서 현장 응급검사를 위해 준비, 채취, 검사를 시행시 점수를 부여한다.',
    ],
    desc: ['해당 없음', '2점 : 2~5회', '4점 : 6회'],
  },
  {
    id: 7,
    ko: '16. 혈액채취(동맥관, 정맥천자)',
    info: [
      '검사실로 보내기 위해 중환자실 직원이 채혈하는 것이 해당된다.',
      '2회 시행이란 튜브 종류가 아니라 venipuncture나 혈액을 채취하는 횟수를 의미하며, ABG, Electro를 동시 채혈하여 튜브 2개에 나눠 담은 경우에는 1회로 한다.',
    ],
    desc: ['해당 없음', '1점 : 2회 이상'],
  },
  {
    id: 8,
    ko: '17. 기타검체채취(객담, 소변, 대변 등)',
    info: [
      '객담, 소변, 대변 등 2회 이상 채취한 것이 해당된다.',
      '중환자실 직원이 객담(TTA포함), 소변, 대변 등을 채취하는 것이 포함되며, 동일검체를 반복 채취한 경우에도 모두 횟수로 인정한다.',
    ],
    desc: ['해당 없음', '2점 : 2회 이상'],
  },
  {
    id: 9,
    ko: '18. 12- 유도 심전도 기록',
    info: ['중환자실 직원이 시행하는 경우에만 해당된다.'],
    desc: ['해당 없음 ', '1회당 2점 :'],
  },
];

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
  sum1: number;
  setSum1: (sum1: number) => void;

  pressure: number;
  setPressure: (pressure: number) => void;

  sum2: number;
  setSum2: (sum2: number) => void;

  ekg: number;
  setEKG: (ekg: number) => void;
}
const KPCSCContents = (props: Props) => {
  const { palette } = useTheme();

  const {
    disabled,
    setValue,
    getValues,
    register,
    setSum1,
    setPressure,
    setSum2,
    setEKG,
  } = props;

  const calculateSumValue1 = () => {
    setSum1(
      radioId.reduce((acc, cur) => {
        if (cur === 'no08' && Number(getValues(cur)) > 0) {
          const value = Number(getValues(cur));
          return value ? acc + value - 1 : acc;
        }
        // 1번
        else if (cur === 'no01' && Number(getValues(cur)) === 3) {
          const value = Number(getValues(cur));
          return value ? acc + value + 1 : acc;
        }
        // 2번, 3번
        else if (
          (cur === 'no02' && Number(getValues(cur)) > 0) ||
          (cur === 'no03' && Number(getValues(cur)) > 0)
        ) {
          if (Number(getValues(cur)) === 1) {
            const value = Number(getValues(cur));
            return value ? acc + value + 1 : acc;
          } else if (Number(getValues(cur)) === 2) {
            const value = Number(getValues(cur));
            return value ? acc + value + 2 : acc;
          } else if (Number(getValues(cur)) === 3) {
            const value = Number(getValues(cur));
            return value ? acc + value + 5 : acc;
          }
        }
        // 4번
        else if (cur === 'no04') {
          const value = Number(getValues(cur)) * 5;
          return value ? acc + value : acc;
        }
        // 5번
        else if (cur === 'no05' && Number(getValues(cur)) === 3) {
          const value = Number(getValues(cur)) + 2;
          return value ? acc + value : acc;
        }
        //  7번
        else if (cur === 'no07') {
          if (Number(getValues(cur)) === 3) {
            const value = Number(getValues(cur)) * 2 + 2;
            return value ? acc + value : acc;
          }
          const value = Number(getValues(cur)) * 2;
          return value ? acc + value : acc;
        }
        // 6번
        else if (cur === 'no06') {
          if (Number(getValues(cur)) === 4) {
            const value = Number(getValues(cur)) * 3 + 3;
            return value ? acc + value : acc;
          }
          const value = Number(getValues(cur)) * 2;
          return value ? acc + value : acc;
        }
        // 9번
        else if (cur === 'no09') {
          const value = Number(getValues(cur)) * 6;
          return value ? acc + value : acc;
        }
        const value = Number(getValues(cur));
        return value ? acc + value : acc;
      }, 0)
    );
  };

  const handleChange1 = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    calculateSumValue1();
  };

  const [disablePressure, setDisablePressure] = useState(false);

  const handleChange1Pressure_none = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    setValue('no08_1', 0);
    setPressure(0);
    setDisablePressure(true);
    calculateSumValue1();
  };

  const handleChange1Pressure_One = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    setValue('no08_1', 1);
    setPressure(2);
    setDisablePressure(false);
    calculateSumValue1();
  };

  const calculateSumValue2 = () => {
    setSum2(
      radioId1.reduce((acc, cur) => {
        if (cur === 'no18') {
          const value = Number(getValues(cur));
          return value ? acc + value - 1 : acc;
        }
        // 11, 12, 14,15, 17번
        else if (
          cur === 'no11' ||
          cur === 'no12' ||
          cur === 'no14' ||
          cur === 'no15' ||
          cur === 'no17'
        ) {
          const value = Number(getValues(cur)) * 2;
          return value ? acc + value : acc;
        }
        // 10번
        else if (cur === 'no10') {
          if (Number(getValues(cur)) === 1) {
            const value = Number(getValues(cur)) * 2;
            return value ? acc + value : acc;
          } else if (Number(getValues(cur)) === 2) {
            const value = Number(getValues(cur)) * 4;
            return value ? acc + value : acc;
          } else if (Number(getValues(cur)) === 3) {
            const value = Number(getValues(cur)) * 3 + 1;
            return value ? acc + value : acc;
          }
        }
        // 13번
        else if (cur === 'no13') {
          const value = Number(getValues(cur)) * 3;
          return value ? acc + value : acc;
        }

        const value = Number(getValues(cur));
        return value ? acc + value : acc;
      }, 0)
    );
  };

  const handleChange2 = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    calculateSumValue2();
  };

  const [disableEKG, setDisableEKG] = useState(false);

  const handleChange2EKG_none = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    setValue('no18_1', 0);
    setEKG(0);
    setDisableEKG(true);
    calculateSumValue2();
  };

  const handleChange2EKG_One = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    setValue('no18_1', 1);
    setEKG(2);
    setDisableEKG(false);
    calculateSumValue2();
  };

  useEffect(() => {
    calculateSumValue1();
    calculateSumValue2();
  }, []);

  return (
    <>
      <SectionTitle title="영역 : 활력징후 측정 및 감시" />
      <Box sx={{ width: '98%', margin: '20px' }}>
        <TableContainer sx={{ marginTop: '20px', marginBottom: '30px' }}>
          <TableBody>
            {영역1.map(
              (
                content: {
                  id: number;
                  ko: string;
                  info: string[];
                  desc: string[];
                },
                i
              ) => (
                <TableRow>
                  <StyledTableCellTwo
                    sx={{
                      padding: '16px',
                      width: '300px',
                      whiteSpace: 'pre-wrap',
                      verticalAlign: 'top',
                      borderBottom: 영역1.length - 1 === i ? 'none' : '',
                    }}
                  >
                    {content.ko}
                  </StyledTableCellTwo>
                  <StyledTableCellWithoutLeftTwo
                    sx={{
                      borderBottom: 영역1.length - 1 === i ? 'none' : '',
                    }}
                  >
                    <RadioGroup
                      sx={{
                        paddingTop: content.info.length > 1 ? '43px' : '28px',
                        marginTop: content.ko.includes('8.') ? '18px' : '0px',
                      }}
                      name={radioId[content.id - 1]}
                      defaultValue={Number(getValues(radioId[content.id - 1]))}
                    >
                      {content.desc.map((point, i) => {
                        if (point === '해당 없음 ') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={'no08'}
                                  value={i}
                                  onChange={handleChange1Pressure_none}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (point === '1회당 2점 :') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={'no08'}
                                  value={i}
                                  onChange={handleChange1Pressure_One}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={radioId[content.id - 1]}
                                  value={i}
                                  onChange={handleChange1}
                                />
                              </Box>
                            </TableRow>
                          );
                      })}
                    </RadioGroup>
                  </StyledTableCellWithoutLeftTwo>
                  <StyledTableCellWithoutLeftRightTwo
                    sx={{
                      borderBottom: 영역1.length - 1 === i ? 'none' : '',
                    }}
                  >
                    <Box>
                      {content.info.includes('') ? (
                        <TableRow
                          sx={{
                            height: '21px',
                          }}
                        >
                          <Box sx={{ minWidth: '500px' }}> </Box>
                        </TableRow>
                      ) : content.info.length > 1 ? (
                        content.info.map((item, i) => {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '17px',
                                height: '4px',
                              }}
                            >
                              <Box
                                sx={{
                                  minWidth: '65vw',
                                  marginLeft: '-28px',
                                }}
                              >
                                ・ {item}
                              </Box>
                            </TableRow>
                          );
                        })
                      ) : (
                        content.info.map((item, i) => {
                          return (
                            <TableRow
                              sx={{
                                height: '8.5px',
                              }}
                            >
                              <Box
                                sx={{
                                  minWidth: '65vw',
                                  marginLeft: '-28px',
                                }}
                              >
                                ・ {item}
                              </Box>
                            </TableRow>
                          );
                        })
                      )}
                      {content.desc.map((v, i) => {
                        if (v === '1회당 2점 :') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '42px',
                              }}
                            >
                              <Box sx={{ minWidth: '500px' }}>
                                {v}
                                <Form.MuiTextField
                                  required={false}
                                  type="number"
                                  textAlign="right"
                                  disabled={disablePressure ? true : disabled}
                                  sx={{ width: '200px', marginLeft: '10px' }}
                                  InputProps={{
                                    ...Form.adornment('', '회'),
                                  }}
                                  {...register('no08_1', {
                                    onChange: e => {
                                      setValue(
                                        'no08_1',
                                        Number(e.target.value)
                                      );
                                      setPressure(
                                        Math.floor(getValues('no08_1') * 2)
                                      );
                                    },
                                  })}
                                />
                              </Box>
                            </TableRow>
                          );
                        }
                        return (
                          <TableRow
                            sx={{
                              lineHeight: '42px',
                            }}
                          >
                            <Box sx={{ minWidth: '500px' }}>{v}</Box>
                          </TableRow>
                        );
                      })}
                    </Box>
                  </StyledTableCellWithoutLeftRightTwo>
                </TableRow>
              )
            )}
          </TableBody>
        </TableContainer>

        <SectionTitle title="영역 : 신체사정 및 검사" />
        <TableContainer sx={{ marginTop: '40px', marginBottom: '-30px' }}>
          <TableBody>
            {영역2.map(
              (
                content: {
                  id: number;
                  ko: string;
                  info: string[];
                  desc: string[];
                },
                i
              ) => (
                <TableRow>
                  <StyledTableCellTwo
                    sx={{
                      padding: '16px',
                      width: '300px',
                      whiteSpace: 'pre-wrap',
                      verticalAlign: 'top',
                      borderBottom: 영역2.length - 1 === i ? 'none' : '',
                    }}
                  >
                    {content.ko}
                  </StyledTableCellTwo>
                  <StyledTableCellWithoutLeftTwo
                    sx={{
                      borderBottom: 영역2.length - 1 === i ? 'none' : '',
                    }}
                  >
                    <RadioGroup
                      sx={{
                        paddingTop: content.info.length > 1 ? '55px' : '28px',
                      }}
                      name={radioId1[content.id - 1]}
                      defaultValue={Number(getValues(radioId1[content.id - 1]))}
                    >
                      {content.desc.map((point, i) => {
                        if (point === '해당 없음 ') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={'no18'}
                                  value={i}
                                  onChange={handleChange2EKG_none}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (point === '1회당 2점 :') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={'no18'}
                                  value={i}
                                  onChange={handleChange2EKG_One}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={radioId1[content.id - 1]}
                                  value={i}
                                  onChange={handleChange2}
                                />
                              </Box>
                            </TableRow>
                          );
                      })}
                    </RadioGroup>
                  </StyledTableCellWithoutLeftTwo>
                  <StyledTableCellWithoutLeftRightTwo
                    sx={{
                      borderBottom: 영역2.length - 1 === i ? 'none' : '',
                    }}
                  >
                    <Box>
                      {content.info.includes('') ? (
                        <TableRow
                          sx={{
                            height: '16px',
                          }}
                        >
                          <Box sx={{ minWidth: '500px' }}> </Box>
                        </TableRow>
                      ) : content.info.length > 1 ? (
                        content.info.map((item, i) => {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '23px',
                                height: '4px',
                              }}
                            >
                              <Box
                                sx={{ minWidth: '65vw', marginLeft: '-28px' }}
                              >
                                ・ {item}
                              </Box>
                            </TableRow>
                          );
                        })
                      ) : (
                        content.info.map((item, i) => {
                          return (
                            <TableRow
                              sx={{
                                height: '8.5px',
                              }}
                            >
                              <Box
                                sx={{ minWidth: '65vw', marginLeft: '-28px' }}
                              >
                                ・ {item}
                              </Box>
                            </TableRow>
                          );
                        })
                      )}
                      {content.desc.map((v, i) => {
                        if (v === '1회당 2점 :') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '42px',
                              }}
                            >
                              <Box sx={{ minWidth: '500px' }}>
                                {v}
                                <Form.MuiTextField
                                  required={false}
                                  type="number"
                                  textAlign="right"
                                  disabled={disableEKG ? true : disabled}
                                  sx={{ width: '200px', marginLeft: '10px' }}
                                  InputProps={{
                                    ...Form.adornment('', '회'),
                                  }}
                                  {...register('no18_1', {
                                    onChange: e => {
                                      setValue(
                                        'no18_1',
                                        Number(e.target.value)
                                      );
                                      setEKG(
                                        Math.floor(getValues('no18_1') * 2)
                                      );
                                    },
                                  })}
                                />
                              </Box>
                            </TableRow>
                          );
                        }
                        return (
                          <TableRow
                            sx={{
                              lineHeight: '42px',
                            }}
                          >
                            <Box sx={{ minWidth: '500px' }}>{v}</Box>
                          </TableRow>
                        );
                      })}
                    </Box>
                  </StyledTableCellWithoutLeftRightTwo>
                </TableRow>
              )
            )}
          </TableBody>
        </TableContainer>
      </Box>
    </>
  );
};

export default KPCSCContents;
